import { registerWallet } from '@wallet-standard/wallet';
import { SolflareWallet } from './wallet';
import { initializeWhenDetected as initializeMetaMaskWhenDetected } from '@solflare-wallet/metamask-wallet-standard';
let isInitialized = false;
export function initialize({ disableMetaMask } = {}) {
    if (typeof window === 'undefined') {
        return;
    }
    if (isInitialized) {
        return;
    }
    if (window && window.solflareWalletStandardInitialized) {
        return;
    }
    isInitialized = true;
    if (window) {
        window.solflareWalletStandardInitialized = true;
    }
    if (!disableMetaMask) {
        initializeMetaMaskWhenDetected();
    }
    registerWallet(new SolflareWallet());
}
